import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { faFacebookF, faTwitter, faInstagram, faLinkedinIn } from '@fortawesome/free-brands-svg-icons';
import axios from 'axios';

const Footer = () => {
  const [contactInfo, setContactInfo] = useState({
    'Our Office': null,
    'Phone': null,
    'Email': null,
    'Working Hours': null,
    'Connect With Us': null
  });

  useEffect(() => {
    fetchContactInfo();
  }, []);

  const fetchContactInfo = async () => {
    try {
      const response = await axios.get('https://realestate.bonlineco.com/api/contact-information');
      if (response.data.status === 'success') {
        const info = {};
        response.data.data.forEach(item => {
          if (item.is_visible) {
            info[item.type] = item;
          }
        });
        setContactInfo(info);
      }
    } catch (error) {
      console.error('Failed to fetch contact information:', error);
    }
  };
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>About Us</h3>
            <p>
              We are a modern real estate company dedicated to helping you find your dream property.
              With years of experience and a passion for real estate, we provide exceptional service.
            </p>
            <div className="social-icons">
              {contactInfo['Connect With Us']?.social_links?.facebook && (
                <a href={contactInfo['Connect With Us'].social_links.facebook} target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faFacebookF} />
                </a>
              )}
              {contactInfo['Connect With Us']?.social_links?.twitter && (
                <a href={contactInfo['Connect With Us'].social_links.twitter} target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faTwitter} />
                </a>
              )}
              {contactInfo['Connect With Us']?.social_links?.instagram && (
                <a href={contactInfo['Connect With Us'].social_links.instagram} target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faInstagram} />
                </a>
              )}
              {contactInfo['Connect With Us']?.social_links?.linkedin && (
                <a href={contactInfo['Connect With Us'].social_links.linkedin} target="_blank" rel="noopener noreferrer">
                  <FontAwesomeIcon icon={faLinkedinIn} />
                </a>
              )}
            </div>
          </div>
          
          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul>
              <li><Link to="/">Homes</Link></li>
              <li><Link to="/properties">Properties</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/contact">Contacts</Link></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h3>Contact Info</h3>
            <ul>
              {contactInfo['Our Office'] && (
                <li>
                  <FontAwesomeIcon icon={faMapMarkerAlt} />
                  {contactInfo['Our Office'].value}
                </li>
              )}
              {contactInfo['Phone'] && (
                <li>
                  <FontAwesomeIcon icon={faPhone} />
                  {contactInfo['Phone'].value}
                </li>
              )}
              {contactInfo['Email'] && (
                <li>
                  <FontAwesomeIcon icon={faEnvelope} />
                  {contactInfo['Email'].value}
                </li>
              )}
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Real Estate Website. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
